/* src/app/admin-dashboard/system-info/system-info.component.css */
.table-container {
  margin: 20px;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  padding: 10px;
  text-align: center;
  border: 1px solid #ddd;
}
mat-icon {
  font-size: 24px;
  color: #2196f3;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
ul li {
  margin-bottom: 5px;
}
ul ul {
  padding-left: 20px;
}
td[rowspan] {
  vertical-align: middle;
}
/*# sourceMappingURL=system-info.component.css.map */
